import { getCurrentEnvironment } from './getEnvironment'

export const ONBOARDING_COOKIE_NAME = 'ash_onboarding_incomplete'

function buildBaseAttributes(): string {
  const attributes: string[] = ['Path=/', 'SameSite=Lax']
  if (typeof window !== 'undefined' && window.location?.protocol === 'https:') {
    attributes.push('Secure')
  }
  return attributes.join('; ')
}

export function setOnboardingIncompleteCookie(
  hoursToLive = getCurrentEnvironment() === 'development' ? 24 : 1,
): void {
  if (typeof document === 'undefined') return
  const maxAge = Math.max(1, Math.floor(hoursToLive * 60 * 60))
  const base = buildBaseAttributes()
  document.cookie = `${ONBOARDING_COOKIE_NAME}=true; Max-Age=${maxAge}; ${base}`
}

export function clearOnboardingCookie(): void {
  if (typeof document === 'undefined') return
  const base = buildBaseAttributes()
  document.cookie = `${ONBOARDING_COOKIE_NAME}=; Max-Age=0; ${base}`
}

export function isOnboardingCookieSetClient(): boolean {
  if (typeof document === 'undefined') return false
  return document.cookie.split(';').some((c) => c.trim().startsWith(`${ONBOARDING_COOKIE_NAME}=`))
}
